import React from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import ViewModal from '../../CommonModals/viewModal';
import NewUserModal from '../../CommonModals/NewUserModal';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';
import FormModal from '../../../Form/FormModal';
import store from '../../../App/store';
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service"
import RolePermissions from '../../CommonModals/Permissions';
// config file
export default class Teachers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageData: '',
      rolePermission: "",
      rolesList: [],
      editSelectedRecord:window.location.href.includes("edit"),
      addSelectedRecord:window.location.href.includes("create"),
      viewSelectedRecord:window.location.href.includes("view"),	
    };
    this.getRoleListFromServer()
  }

  static getDerivedStateFromProps(props, state) {
    let storeData = store.getState()
    let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
    return { languageData: languageData };
  }
  componentDidMount = () => {
    //Screen permisions value can be edit,view, no view
    let screenPermissions = RolePermissions.screenPermissions('Provideremployee');
    if (screenPermissions) {
      this.setState({
        rolePermission: screenPermissions
      })
    }
    // this.getRoleListFromServer()
  }
  setData = (props) => {
    let rowData = {}
    if (props && props.match && props.match.params && props.match.params.id) {
      rowData["_id"] = JSON.parse(props.match.params.id)
      return rowData
    }
  }
  getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest('GET', url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = []
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }

          await this.setState({ rolesList: rolesList });
        }
      }).catch((err) => { return err })
  };
  getTableFields = () => {
    let { languageData } = this.state
    let roleTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Admin',
        value: 'Admin'
      },
      {
        label: 'Super Admin',
        value: 'Super Admin'
      },
      {
        label: 'User',
        value: 'User'
      },
    ];
    let StatusTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      }
    ];
    let data = [
      {
        "textAlign": "center",
        "width": 47,
        "field": "Check Box",
        "label": "Check Box",
        "fieldType": "multiple",
        "header": "",
        "selectionMode": "multiple",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "textAlign": "center",
        "width": 47,
        "field": "Sno",
        "label": "SNo",
        "header": "SNo",
        "filter": false,
        "sortable": false,
        "placeholder": "Search",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "Id",
        "type": "text",
        "placeholder": "ID",
        "label": "ID",
        "width": "90px",
        "header": "ID",
        "derivedValue": "Id=doctorId=doctorId=doctorId=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter":true,
        "actions": [],
        "actionsNumber": [],
        "id": "Id",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "Id",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "Link",
        "style": {
          "color": "#0e4768",
          "cursor": "pointer",
          "textTransform": "capitalize"
        }
      },
      // {
      //   "name": "Name",
      //   "type": "text",
      //   "placeholder": "Name",
      //   "label": "Name",
      //   "width": "130px",
      //   "header": "Name",
      //   "derivedValue": "Name=doctorName=doctorName=doctorName=contactName=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "id": "Name",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "true",
      //   "required": true,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "Name",
      //   "filter": true,
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "displayName",
        "type": "text",
        "placeholder": "Name",
        "label": "displayName",
        "header": "Name",
        "width": "150px",
        "id": "displayName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "textAlign": "Center",
        "globalSearchField": "true",
        "show": true,
        "field": "displayName",
        "mobile": true,
        "filter": true,
        "sortable":true,
        "displayInSettings": true
      },
      {
        "name": "email",
        "type": "email",
        "placeholder": "Email",
        "label": "Email",
        "width": "180px",
        "header": "Email",
        "derivedValue": "email=email=doctor_email=doctor_email=doctor_email=contact_email=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "email",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "email",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "phoneNumber",
        "type": "text",
        "placeholder": "Phone Number",
        "label": "Phone Number",
        "width": "130px",
        "header": "Phone Number",
        "derivedValue": "phoneNumber=phoneNumber=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "filter": true,
        "actionsNumber": [],
        "id": "phoneNumber",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "phoneNumber",
        "showOrHideFields": [],
        "fieldName": "phoneNumber",
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "speciality",
        "type": "text",
        "placeholder": "Speciality",
        "label": "Speciality",
        "width": "90px",
        "header": "Speciality",
        "derivedValue": "speciality=speciality=speciality=speciality=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "speciality",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "speciality",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      // {
      //   "name": "provider",
      //   "type": "relateAutoComplete",
      //   "placeholder": "Provider",
      //   "label": "Provider",
      //   "width": "90px",
      //   "header": "Provider",
      //   "derivedValue": "provider=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "provider",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "true",
      //   "required": true,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": 1010,
      //   "searchField": "name",
      //   "fieldType": "relateAutoComplete",
      //   "populteFields": [],
      //   "displayFields": [
      //     "name"
      //   ],
      //   "controllerName": "providers",
      //   "searchApi": "providerss",
      //   "isMultiple": false,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "provider",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "providers_name",
      //   "type": "text",
      //   "placeholder": "providers_name",
      //   "label": "providers_name",
      //   "header": "providers name",
      //   "width": 110,
      //   "parentField": "provider",
      //   "id": "providers_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "providers_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "role",
        "type": "dropDown",
        "placeholder": "Role",
        "label": "Role",
        "width": "120px",
        "header": "Role",
        "derivedValue": "role=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "role",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "fieldType": "dropDown",
        "dependent": [],
        "textAlign": "Center",
        "show": true,
        "field": "role",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "NPI",
        "type": "text",
        "placeholder": "NPI",
        "label": "NPI",
        "width": "100px",
        "header": "NPI",
        "derivedValue": "NPI=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "NPI",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "NPI",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "fax",
        "type": "text",
        "placeholder": "Fax",
        "label": "Fax",
        "width": "130px",
        "header": "Fax",
        "derivedValue": "fax=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "fax",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "formatType": "US",
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "fax",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "joiningDate",
        "type": "date",
        "fieldType": "date",
        "placeholder": "Joining Date",
        "label": "Joining Date",
        "width": "120px",
        "header": "Joining Date",
        "derivedValue": "joiningDate=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "joiningDate",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "field": "joiningDate",
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "address",
        "type": "textarea",
        "placeholder": "Address",
        "label": "Address",
        "width": "150px",
        "header": "Address",
        "derivedValue": "address=address=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "address",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "address",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "alternate_Number",
        "type": "text",
        "placeholder": "Alternate Number",
        "label": "Alternate Number",
        "width": "130px",
        "header": "Alternate Number",
        "derivedValue": "alternate_Number=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "alternate_Number",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "alternate_Number",
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      // {
      //   "name": "dateOfBirth",
      //   "type": "date",
      //   "placeholder": "Date Of Birth",
      //   "label": "Date Of Birth",
      //   "width": "90px",
      //   "header": "Date Of Birth",
      //   "derivedValue": "dateOfBirth=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "dateOfBirth",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": null,
      //   "dateFormat": "DD-MM-YYYY",
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "dateOfBirth",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "comment",
        "type": "textarea",
        "placeholder": "Comment",
        "label": "Comment",
        "width": "90px",
        "header": "Comment",
        "derivedValue": "comment=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "comment",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "textAlign": "Center",
        "show": true,
        "field": "comment",
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": '120px',
        "header": "Created",
        "derivedValue": "created=undefined",
        "actions": [],
        "actionsNumber": [],
        "fieldType": "date",
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "created",
        "mobile": true,
        "displayInSettings": true,
        "filter":true,
        "sortable":true
      },
      // {
      //   "name": "createdBy",
      //   "type": "relateAutoComplete",
      //   "placeholder": "CreatedBy",
      //   "label": "CreatedBy",
      //   "width": 90,
      //   "disabled": true,
      //   "header": "CreatedBy",
      //   "derivedValue": "createdBy=undefined",
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "createdBy",
      //   "displayinaddForm": "false",
      //   "displayineditForm": "false",
      //   "displayinlist": "true",
      //   "globalSearchField": "false",
      //   "controllerId": 1001,
      //   "searchField": "displayName",
      //   "fieldType": "relateAutoComplete",
      //   "controllerName": "employee",
      //   "searchApi": "employees",
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "createdBy",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": '120px',
        "header": "Updated",
        "derivedValue": "updated=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updated",
        "fieldType": "date",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "updated",
        "mobile": true,
        "displayInSettings": true,
        "filter":true,
        "sortable":true
      },
      {
        "name": "createdByName",
        "type": "Text",
        "placeholder": "Created By",
        "label": "Created By",
        "width": 120,
        "header": "Created By",
        "id": "createdByName",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "field": "createdByName",
        "mobile": true,
        "filter": true,
        "displayInSettings": true
      },
      {
        "name": "updatedByName",
        "type": "Text",
        "placeholder": "Updated By",
        "label": "Updated By",
        "width": 120,
        "header": "Updated By",
        "id": "updatedByName",
        "displayinlist": "true",
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "filter": true,
        "field": "updatedByName",
        "mobile": true,
        "displayInSettings": true
      },
    ]
        return data;
  };

  getFormFields = () => {
    let { languageData } = this.state
    let statusTypes = [
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      },
    ];
    return ([
      {
        "name": "firstName",
        "type": "text",
        "placeholder": "First Name",
        "label": "First Name",
        "width": 110,
        "id": "firstName",
        "displayinaddForm": "true",
        "required": true,
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 1,
        "editFormOrder": 1
      },
      {
        "name": "lastName",
        "type": "text",
        "placeholder": "Last Name",
        "label": "Last Name",
        "width": 110,
        "id": "lastName",
        "required": true,
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "controllerName": null,
        "fieldType": "Link",
        "globalSearchField": "true",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder": 2,
        "editFormOrder": 2
      },
      {
        "name": "Id",
        "type": "text",
        "placeholder": "ID",
        "label": "ID",
        "width": "90px",
        "derivedValue": "Id=doctorId=doctorId=doctorId=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "Id",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "Link",
        "style": {
          "color": "#0e4768",
          "cursor": "pointer",
          "textTransform": "capitalize"
        },
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      // {
      //   "name": "Name",
      //   "type": "text",
      //   "placeholder": "Name",
      //   "label": "Name",
      //   "width": 110,
      //   "derivedValue": "Name=doctorName=doctorName=doctorName=contactName=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "id": "Name",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "true",
      //   "required": true,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "show": true,
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "isAddFormHidden": false,
      //   "isEditFormHidden": false
      // },
      {
        "name": "email",
        "type": "email",
        "placeholder": "Email",
        "label": "Email",
        "width": "90px",
        "derivedValue": "email=email=doctor_email=doctor_email=doctor_email=contact_email=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "email",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "phoneNumber",
        "type": "text",
        "placeholder": "Phone Number",
        "label": "Phone Number",
        "width": "90px",
        "derivedValue": "phoneNumber=phoneNumber=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "phoneNumber",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "fieldName": "phoneNumber",
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "formatType":"US"
      },
      {
        "name": "role",
        "type": "dropDown",
        "placeholder": "Role",
        "label": "Role",
        "width": "90px",
        "derivedValue": "role=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "role",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "fieldType": "dropDown",
        "dependent": [{'Physician':['speciality','NPI','fax']}],
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false        
      },
      {
        "name": "speciality",
        "type": "text",
        "placeholder": "Speciality",
        "label": "Speciality",
        "width": "90px",
        "derivedValue": "speciality=speciality=speciality=speciality=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "speciality",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": false,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "NPI",
        "type": "text",
        "placeholder": "NPI",
        "label": "NPI",
        "width": "90px",
        "derivedValue": "NPI=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "NPI",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": false,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "fax",
        "type": "text",
        "placeholder": "Fax",
        "label": "Fax",
        "width": "90px",
        "derivedValue": "fax=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "fax",
        "formatType": "US",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": false,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "provider",
        "type": "relateAutoComplete",
        "placeholder": "Provider",
        "label": "Provider",
        "width": "90px",
        "derivedValue": "provider=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "provider",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [
          "name"
        ],
        "controllerName": "providers",
        "searchApi": "providerss",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": true,
        "disable": true
      },
      {
        "name": "joiningDate",
        "type": "date",
        "placeholder": "Joining Date",
        "label": "Joining Date",
        "width": "90px",
        "derivedValue": "joiningDate=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "joiningDate",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      
      {
        "name": "alternate_Number",
        "type": "text",
        "placeholder": "Alternate Number",
        "label": "Alternate Number",
        "width": "90px",
        "derivedValue": "alternate_Number=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "alternate_Number",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "mobile": true,
        "formatType": "US",
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "dateOfBirth",
        "type": "date",
        "placeholder": "Date Of Birth",
        "label": "Date Of Birth",
        "width": "90px",
        "derivedValue": "dateOfBirth=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "dateOfBirth",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "password",
        "type": "password",
        "placeholder": "Password",
        "label": "Password",
        "width": "90px",
        "derivedValue": "password=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "password",
        "displayinaddForm": "true",
        "displayineditForm": "false",
        "displayinlist": "false",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": true
      },
      {
        "name": "address",
        "type": "textarea",
        "placeholder": "Address",
        "label": "Address",
        "width": "90px",
        "derivedValue": "address=address=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "address",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "comment",
        "type": "textarea",
        "placeholder": "Comment",
        "label": "Comment",
        "width": "90px",
        "derivedValue": "comment=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "comment",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },      
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 90,
        "derivedValue": "created=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "createdBy",
        "type": "relateAutoComplete",
        "placeholder": "CreatedBy",
        "label": "CreatedBy",
        "width": 90,
        "disabled": true,
        "derivedValue": "createdBy=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "createdBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "displayName",
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 90,
        "derivedValue": "updated=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updatedBy",
        "type": "relateAutoComplete",
        "placeholder": "UpdatedBy",
        "label": "UpdatedBy",
        "width": 90,
        "derivedValue": "updatedBy=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updatedBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "displayName",
        "disabled": true,
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      }
    ]);
  }

  submit = async (item) => {

    this.setState({ isOpenFormModal: true })
    await this.formModalRef.getRowData(item, 'edit');

    console.log("Submit Button in sode          ")
  }
  getMobileTableFields = () => {
    let data = [{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"Id","type":"text","placeholder":"ID","label":"ID","width":"90px","header":"ID","derivedValue":"Id=doctorId=doctorId=doctorId=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"Id","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"Id","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"Name","type":"text","placeholder":"Name","label":"Name","width":110,"header":"Name","derivedValue":"Name=doctorName=doctorName=doctorName=contactName=undefined","capitalizeTableText":false,"sortable":false,"id":"Name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"Name","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"email","type":"email","placeholder":"Email","label":"Email","width":"90px","header":"Email","derivedValue":"email=email=doctor_email=doctor_email=doctor_email=contact_email=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"actions":[],"actionsNumber":[],"id":"email","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"email","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"phoneNumber","type":"text","placeholder":"Phone Number","label":"Phone Number","width":"90px","header":"Phone Number","derivedValue":"phoneNumber=phoneNumber=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"phoneNumber","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"phoneNumber","showOrHideFields":[],"fieldName":"phoneNumber","mobile":true,"displayInSettings":true},{"name":"speciality","type":"text","placeholder":"Speciality","label":"Speciality","width":"90px","header":"Speciality","derivedValue":"speciality=speciality=speciality=speciality=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"speciality","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"speciality","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"provider","type":"relateAutoComplete","placeholder":"Provider","label":"Provider","width":"90px","header":"Provider","derivedValue":"provider=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"provider","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1010,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["name"],"controllerName":"providers","searchApi":"providerss","isMultiple":false,"textAlign":"Center","show":true,"field":"provider","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"providers_name","type":"text","placeholder":"providers_name","label":"providers_name","header":"providers name","width":110,"parentField":"provider","id":"providers_name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"name","show":true,"field":"providers_name","mobile":true,"displayInSettings":true},{"name":"role","type":"dropDown","placeholder":"Role","label":"Role","width":"90px","header":"Role","derivedValue":"role=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"actions":[],"actionsNumber":[],"id":"role","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":true,"field":"role","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"NPI","type":"text","placeholder":"NPI","label":"NPI","width":"90px","header":"NPI","derivedValue":"NPI=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"NPI","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"NPI","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"fax","type":"text","placeholder":"Fax","label":"Fax","width":"90px","header":"Fax","derivedValue":"fax=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"fax","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"fax","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"joiningDate","type":"date","placeholder":"Joining Date","label":"Joining Date","width":"90px","header":"Joining Date","derivedValue":"joiningDate=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"joiningDate","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","show":true,"field":"joiningDate","mobile":true,"displayInSettings":true},{"name":"address","type":"textarea","placeholder":"Address","label":"Address","width":"90px","header":"Address","derivedValue":"address=address=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"address","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"address","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"alternate_Number","type":"text","placeholder":"Alternate Number","label":"Alternate Number","width":"90px","header":"Alternate Number","derivedValue":"alternate_Number=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"alternate_Number","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"alternate_Number","mobile":true,"displayInSettings":true},{"name":"dateOfBirth","type":"date","placeholder":"Date Of Birth","label":"Date Of Birth","width":"90px","header":"Date Of Birth","derivedValue":"dateOfBirth=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"dateOfBirth","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","show":true,"field":"dateOfBirth","mobile":true,"displayInSettings":true},{"name":"comment","type":"textarea","placeholder":"Comment","label":"Comment","width":"90px","header":"Comment","derivedValue":"comment=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"comment","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"comment","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"createdBy","type":"relateAutoComplete","placeholder":"CreatedBy","label":"CreatedBy","width":90,"disabled":true,"header":"CreatedBy","derivedValue":"createdBy=undefined","actions":[],"actionsNumber":[],"id":"createdBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"createdBy","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"name":"updatedBy","type":"relateAutoComplete","placeholder":"UpdatedBy","label":"UpdatedBy","width":90,"header":"UpdatedBy","derivedValue":"updatedBy=undefined","actions":[],"actionsNumber":[],"id":"updatedBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","disabled":true,"fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"updatedBy","mobile":true,"displayInSettings":true},{"name":"password","type":"text","placeholder":"Password","label":"Password","width":"90px","header":"Password","derivedValue":"password=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"password","displayinaddForm":"true","displayineditForm":"false","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"password","showOrHideFields":[],"mobile":true,"displayInSettings":true}]

    return data;
  };
  closeFormModal = async () => {
    this.setState({
      isOpenFormModal: false,
    })
  }
  // submit1 = item => {
  //   let x = hospitalemployeesFields
  //   let objhospitalemployees = {}

  //   objhospitalemployees["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objhospitalemployees[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objhospitalemployees,
  //     newFormFields: formFields
  //   });
  // }
  
  cancelReset = async (type) => {
    this.setState({
      openNewUserModal: false
    });
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  getChangedRoleOptions = () => {
    let fields = this.getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          this.state.rolesList.forEach((roleData) => {
            if(roleData.value === 'physician'){              
              roleData['dependent'] = ['speciality','NPI','fax'];
            }
          })
          obj.options = this.state.rolesList && this.state.rolesList.length > 0 ? this.state.rolesList : [];
        }
      }
    }
    return fields;
  }
  saveDataToServer = async (item, field, value) => {
    let body = item[0]
    body[field] = value
    let userBody = Object.assign({}, body);
    this.setState({
      isLoading: true
    });
    if (body) {
      let method, apiUrl;
      method = 'PUT';
      apiUrl = `${apiCalls.Hospitalemployees}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, 'success');

          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, 'error');
          }
          this.setState({
            isLoading: false
          });
        }).catch((err) => {
          return err;
        });
    } else {
      return;
    }
  }
  render() {
    return (
      <span>
        <DataTables
          {...this.props}
          onRef={ref => (this.dataTableRef = ref)}
          // MobileTableFields={this.getMobileTableFields}
          // getTableFields={this.getTableFields}
          // formFields={this.getFormFields}
          // 
addRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
editRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
deleteRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
viewRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
exportRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
sample={true}
          // globalSearch={'Display Name/Email'}
          // type='Hospitalemployees'
          // apiUrl={apiCalls.Hospitalemployees}
          getTableFields={this.getTableFields}
          formFields={this.getChangedRoleOptions}
          // exportRequried={true}

          printRequried={true}
          actionsTypes={[
            {
              'name': 'Edit',
              "options": [
                { 'label': 'Edit', 'value': 'Edit', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": false, },
              ]
            },

            {
              'name': 'Delete',
              "options": [
                { 'label': 'Delete', 'value': 'Delete', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": true, },
              ]
            },
            
            // {
            //   'name': 'Block',
            //   "options": [
            //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'ResetPassword',
            //   "options": [
            //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
            //   ]
            // },
            // {
            //   'name': 'Submit',
            //   'action': this.submit,
            //   "options": [
            //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
            //   ]
            // },
            // {
            //   name: "newModel",
            //   action: this.submit1,
            //   options: [
            //     { label: "newModel", value: "newModel", show: true, multiple: false }
            //   ]
            // }
            
          ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={true}
          exportToCsv={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          sampleFilePath={filePath.hospitalemployees}
          setData={this.setData}
          editSelectedRecord={this.state.editSelectedRecord}
          addSelectedRecord={this.state.addSelectedRecord}
          viewSelectedRecord={this.state.viewSelectedRecord}
          globalSearch={"Id/Name/email/speciality/role/NPI/fax/alternate_Number/comment"}
          type='Provider employee'
          routeTo={apiCalls.Provideremployees}
          displayViewOfForm='screen'
          apiResponseKey={apiCalls.Provideremployees}
          apiUrl={apiCalls.Provideremployees}

        />
        {this.state.isOpenFormModal ? (
          <FormModal
            onRef={(ref) => (this.formModalRef = ref)}
            formType="edit"
            openFormModal={this.state.isOpenFormModal}
            formFields={this.props.formFields}
          />

        ) : null}
        {this.state.openNewUserModal ? (
          <NewUserModal
            openNewUserModal={this.state.openNewUserModal}
            cancelReset={this.cancelReset}
            item={this.state.item}
            newFormFields={this.state.newFormFields}
            recordId={this.state.item._id}
            entityType="provideremployee"
            apiUrl={apiCalls.Provideremployees}
          />
        ) : null}
      </span>
    );
  }
}